import http from '@/utils/http.js'
/*
 * @DESC:api接口
 */
const 	GET_USER_INFO = "/api/getUserInfo",//获取用户信息	
		ADMIN_LOGIN = "/api/login",//后台登录
		ADMIN_REGISTER = "/api/register",//注册
		ADMIN_OUT_LOGIN = "/api/outLogin",//后台退出登录
		UPDATE_ADMIN = "/api/modifyUserInfo",//修改个人信息
		MODIFY_PASSWORD = "/api/modifyPassword",//修改登录密码
		REGISTER_FULLPAGE = "/api/registerFullpage",//注册急速验证
		SEND_SMS_CODE = "/api/sendSmsCode",//获取短信验证码
		RESET_PWD = "/api/resetPwd";//重置密码
		
		
		

export default {
	login: ({//登录
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		return http.post(ADMIN_LOGIN, params)
	},
	register: ({//注册
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		return http.post(ADMIN_REGISTER, params)
	},
	outLogin: ({//退出登录
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		return http.post(ADMIN_OUT_LOGIN, params)
	},
	getUserInfo: async({//获取用户信息
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		const data = await http.get(GET_USER_INFO,params) 
		commit('GET_USER_INFO', data)
	},
	modifyUserInfo:async({//修改用户信息
		commit,
		dispatch,
		state,
		getters
	},params={}) =>{
		try{
			const data = await http.post(UPDATE_ADMIN,params)
			commit('GET_USER_INFO',params)
			dispatch('getUserInfo')
		}catch(e){
			throw e
		}
	},
	modifyPwd:({//修改密码
		commit,
		dispatch,
		state,
		getters
	},params={}) =>{
		return http.post(MODIFY_PASSWORD,params)
	},
	registerFullpage:({//注册急速验证
		commit,
		dispatch,
		state,
		getters
	},params={}) =>{
		return http.get(REGISTER_FULLPAGE,params)
	},
	sendSmsCode:({//获取验证码
		commit,
	},params={}) =>{
		return http.post(SEND_SMS_CODE,params)
	},
	resetPwd:({//找回密码
		commit,
	},params={}) =>{
		return http.post(RESET_PWD,params)
	}
}


// WEBPACK FOOTER //
// ./src/store/mp/user_center/users/actions.js